var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('document-toolbar-action',{attrs:{"id":"documentViewMarkAsFavorite","icon":"star_border","text":"document.favoriteButton","action":_vm.addToFavoriteAsync,"isButton":_vm.isButton,"enable":_vm.enable && !_vm.isMarkedAsFavorite}})}
var staticRenderFns = []

export { render, staticRenderFns }